import {
    EDIT_USUARIO,
    FETCH_USUARIOS,
    FETCH_TOKEN_RESET_PASSWORD,
    FETCH_USUARIO,
    SET_FILTRO_USUARIOS,
    LOADING_USUARIOS,
    UPDATE_LIST_USUARIOS,
    RESET_FILTRO_USUARIO,
    RESET_USUARIO,
    CHAT_NEW_REQUEST,
    CHAT_REQUEST_ACCEPTED,
    CHAT_CLEAR_REQUEST,
    CHAT_CANCEL_REQUEST,
    FETCH_TIPOS_USUARIOS,
    FETCH_ACCIONES_TIPO_USUARIO,
    FETCH_ACCIONES,
} from '../actions/types';

const initialState = {
    isLoading: false,
    filtro: {},
    usuarios: [],
    usuario: {},
    user: {},
    token: "",
    error: false,
    cantidadTotal: "",
    cantidadPagina: "",
    pendingRequest: false,
    chatRequestData: null,
    tiposUsuarios: [],
    acciones: [],
}

export default function (state = initialState, action) {
    switch (action.type) {
        case EDIT_USUARIO:
            if (action.payload.nuevoPassword !== action.payload.confirmarPassword) {
                return { ...state, usuario: action.payload, user: { ...action.payload }, error: true }
            } else {
                return { ...state, usuario: action.payload, user: { ...action.payload }, error: false }
            }
        case LOADING_USUARIOS:
            return {
                ...state,
                isLoading: action.payload
            };
        case FETCH_USUARIOS:
            return {
                ...state,
                usuarios: action.payload,
                cantidadTotal: action.payload.cantidadTotal,
                cantidadPagina: action.payload.cantidadPagina,
            };
        case SET_FILTRO_USUARIOS:
            return {
                ...state,
                filtro: action.payload
            };
        case RESET_FILTRO_USUARIO:
            return {
                ...state,
                usuarios: action.payload,
                filtro: action.payload,
            };
        case FETCH_TOKEN_RESET_PASSWORD:
            return {
                ...state,
                token: action.payload
            };

        case FETCH_USUARIO: {
            const fetchedUser = (action?.payload?.usuario?.length > 0)
                ? action.payload.usuario[0]
                : {};
            return {
                ...state,
                user: fetchedUser,
                usuario: fetchedUser
            };
        }
        case RESET_USUARIO:
            return {
                ...state,
                user: action.payload,
                usuario: action.payload || {}
            };

        case UPDATE_LIST_USUARIOS:
            return {
                ...state,
                usuarios: action.payload.usuarios,
                cantidadTotal: action.payload.cantidadTotal || state.cantidadTotal,
                cantidadPagina: action.payload.cantidadPagina || state.cantidadPagina,
            };

        case CHAT_NEW_REQUEST:
            return {
                ...state,
                pendingRequest: true,
                chatRequestData: action.payload
            };
        case CHAT_REQUEST_ACCEPTED:
            return {
                ...state,
                pendingRequest: false,
            };
        case CHAT_CLEAR_REQUEST:
        case CHAT_CANCEL_REQUEST:
            return {
                ...state,
                pendingRequest: false,
                chatRequestData: null
            };
        case FETCH_TIPOS_USUARIOS:
            return {
                ...state,
                tiposUsuarios: action.payload,
            };
        case FETCH_ACCIONES_TIPO_USUARIO:
            return {
                ...state,
                accionesTipoUsuario: action.payload
            };
        case FETCH_ACCIONES:
            return {
                ...state,
                acciones: action.payload
            };

        default: return state
    }
}